import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
export var EnrollmentType;
(function (EnrollmentType) {
    EnrollmentType["Waterfall"] = "waterfall";
    EnrollmentType["MyTables"] = "my_tables";
    EnrollmentType["Icp"] = "icp";
})(EnrollmentType || (EnrollmentType = {}));
export var EnrollmentAction;
(function (EnrollmentAction) {
    EnrollmentAction["Join"] = "join";
    EnrollmentAction["Dismiss"] = "dismiss";
})(EnrollmentAction || (EnrollmentAction = {}));
export const getUserActivity = () => __awaiter(void 0, void 0, void 0, function* () {
    return AjaxUtils.get('/api/v1/user-activity/activity');
});
export const submitUserFeedback = (feedbackData) => __awaiter(void 0, void 0, void 0, function* () {
    return AjaxUtils.post('/api/v1/user-activity/feedback', feedbackData);
});
export const submitContactsActivity = (_a) => __awaiter(void 0, [_a], void 0, function* ({ action, contacts }) {
    return AjaxUtils.post('/api/v1/user-activity/contacts', { action, contacts });
});
export const getEnrollments = () => __awaiter(void 0, void 0, void 0, function* () {
    return AjaxUtils.get('/api/v1/user-activity/enrollments');
});
export const createOrUpdateEnrollment = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    return AjaxUtils.post('/api/v1/user-activity/enrollments', payload);
});
